module.exports = __webpack_public_path__ + "img/full7-min.3681e4ff.png";